import { refId } from "@suse-o11y/ref-id";
import { useMonitor } from "@suse-o11y/signal";
import type { FormList } from "@suse-o11y/signal/form";
import React from "react";

import { splice } from "~/tools/splice";

import type { TimeRange } from "../../app/state/view/timeline/TimeRange";
import { FormState as QueryFormState } from "../widget-form/query/form-state";

import { Query } from "./_query";

export interface QueriesProps {
	timeRange: TimeRange;
	queries: FormList<QueryFormState>;
}

export const Queries: React.FC<QueriesProps> = ({ timeRange, queries }) => {
	const monitor = useMonitor();

	return (
		<div>
			<ol className="space-y-4">
				{queries.getElements(monitor).map((query, index, arr) => (
					<li key={refId(query)}>
						<Query
							name={`Query #${index + 1}`}
							onDelete={
								arr.length > 1
									? () => {
											queries.setInput(splice(index, 1, []));
										}
									: undefined
							}
							query={query}
							timeRange={timeRange}
						/>
					</li>
				))}
			</ol>

			<footer className="mt-6 flex flex-row gap-3">
				<button
					className="button button-secondary uppercase"
					onClick={() => {
						queries.setInput((current) => [...current, QueryFormState.initial]);
					}}
					type="button"
				>
					Add query
				</button>

				{queries.isDirty(monitor) && (
					<button className="button button-tertiary uppercase" onClick={() => queries.reset()} type="button">
						Reset queries
					</button>
				)}
			</footer>
		</div>
	);
};
